import Typography from '@eduzz/houston-ui/Typography';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import PermissionHide from 'components/PermissionHide';
import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';
import Tour from 'v2/components/Shared/Tour';
import { sendEventToGA } from 'v2/helpers/analytics';
import salesService from 'v2/services/sales/general';

import Statics from './Statics';
import { steps } from './tour';
import Export from '../Reports/export';

const useStyle = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  '@media screen and (min-width: 600px)': {
    root: {
      background: '#ffff',
      borderRadius: 4,
      boxShadow: '0 1px 0 0 rgba(0,0,0,0.07)',
      width: '100%',
      marginBottom: theme.spacing(2),
    },
  },
  dividerVertical: {
    height: 38,
  },
  gridContainer: {
    borderRadius: '4px 4px 0 0',
  },
  gridItemText: {
    color: '#37474F',
  },
  staticsOpen: {
    background: '#ECEFF1',
  },
  tagsVisibilityIcon: {
    color: '#061D37',
    marginRight: 13,
  },
  expandIcon: {
    marginLeft: '0.5rem',
    color: '#B0BEC5',
  },
}));

export interface IDetailsProps {}

const Details = () => {
  const classes = useStyle({});
  const [isStaticsOpen, setIsStaticsOpen] = useState(false);

  const handleToggleResult = () => {
    setIsStaticsOpen((prevOpen) => {
      const isClosing = !prevOpen === false;
      sendEventToGA({
        category: 'Sales',
        action: isClosing ? 'Fechar' : 'Abrir',
        label: 'Botão Estatísticas',
      });
      return !prevOpen;
    });
  };

  const toggleTagsVisibility = () => salesService.toggleTagsVisibility();

  const [totalCurrency] = useObservable(() => salesService.getTotalCurrency(), []);
  const [totalItems] = useObservable(() => salesService.getTotalItems(), []);
  const [loading] = useObservable(() => salesService.isLoading(), []);
  const [isTagsVisible] = useObservable(() => salesService.getTagsVisible(), []);

  if (loading) return null;

  return (
    <>
      <Tour name='sales_dash' steps={steps} disableScrolling />

      <div className={classes.root} id='sales-details'>
        <Grid className={classes.gridContainer} container alignItems='center'>
          <Grid item>
            <ListItem>
              <Typography className={classes.gridItemText} weight='semibold'>
                {totalItems} faturas
              </Typography>
            </ListItem>
          </Grid>
          <Divider className={classes.dividerVertical} orientation='vertical' />
          <Grid item>
            <ListItem>
              <Typography className={classes.gridItemText} weight='semibold'>
                Ganho Líquido:{' '}
                <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
                  <ColoredFormattedNumber value={totalCurrency} format='BRL' />
                </PermissionHide>
                <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
                  <em>oculto</em>
                </PermissionHide>
              </Typography>
            </ListItem>
          </Grid>
          <Divider className={classes.dividerVertical} orientation='vertical' />

          <Grid item id='sales-dash-statics'>
            <ListItem className={isStaticsOpen && classes.staticsOpen} button onClick={handleToggleResult}>
              <Typography className={classes.gridItemText} weight='semibold'>
                Estatísticas
              </Typography>
              {!isStaticsOpen && <ExpandLess className={classes.expandIcon} />}
              {isStaticsOpen && <ExpandMore id='sales-invoice-result-button-open' className={classes.expandIcon} />}
            </ListItem>
          </Grid>
          <Divider className={classes.dividerVertical} orientation='vertical' />
          <Grid item id='sales-dash-toggle-tags'>
            <Tooltip title={isTagsVisible ? 'Ocultar' : 'Exibir'} placement='top'>
              <ListItem button onClick={toggleTagsVisibility}>
                {isTagsVisible && <VisibilityOff className={classes.tagsVisibilityIcon} />}
                {!isTagsVisible && <Visibility className={classes.tagsVisibilityIcon} />}
                <Typography className={classes.gridItemText} weight='semibold'>
                  Tags
                </Typography>
              </ListItem>
            </Tooltip>
          </Grid>

          <Grid item style={{ marginLeft: 'auto' }}>
            <Export />
          </Grid>
        </Grid>
        <Collapse in={isStaticsOpen} timeout={300} mountOnEnter>
          <Statics />
        </Collapse>
      </div>
    </>
  );
};
export default Details;
